import { render } from "./AppViewItem.vue?vue&type=template&id=8749332e&scoped=true"
import script from "./AppViewItem.vue?vue&type=script&lang=js"
export * from "./AppViewItem.vue?vue&type=script&lang=js"

import "./AppViewItem.vue?vue&type=style&index=0&id=8749332e&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8749332e"]])

export default __exports__